"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('tool', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M4 16C4 22.6274 9.37258 28 16 28C18.0267 28 19.9361 27.4975 21.6104 26.6104L39 44L44 39L26.6104 21.6104C27.4975 19.9361 28 18.0267 28 16C28 9.37258 22.6274 4 16 4C13.9733 4 12.0639 4.50245 10.3896 5.38959L18 13L13 18L5.38959 10.3896C4.50245 12.0639 4 13.9733 4 16Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  })));
});

exports.default = _default;